module.exports = __webpack_public_path__ + "img/slide-2.65baea7.webp";